"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecmaVersion = 11;
